import { render, staticRenderFns } from "./gewenste-breedte-dakkapel.vue?vue&type=template&id=a375c2ba"
import script from "./gewenste-breedte-dakkapel.vue?vue&type=script&lang=js"
export * from "./gewenste-breedte-dakkapel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports